<template>
	<div class="detail-content ofl">
		<div class="content detail-border">
			<img class="detail_imgTop" src="../../assets/images/detail_top.png" />
			<h1 class="text-center">{{title}}</h1>
			<video v-if="video" :src="video" controls="controls"></video>
			<div class="news_detail" v-if="multext" v-html="multext">
		</div>
	</div>
	</div>
</template>
<script>
	import * as api from "@/api/hjy";
	export default {
	  name: "NewsDetail",
	  data(){
	        return {
			   title:'',
			   multext:'',
			   video:'',
	        }
	   },
	   methods: {
				getDetail(){
					if(!this.$route.query.id || !this.$route.query.handler || !this.$route.query.filed){
						alert('缺少必要的参数')
						this.$router.push('/')
					}else{
						let {id,handler,filed} = this.$route.query;
						if(filed == 'goodsDesc'){
							api[handler]({id})
							.then(res=>{
								this.multext = res.data.info.goodsDesc;
								this.title = res.data.title;
								document.title = '湖南安邦制药股份有限公司_'+res.data.info.matName;
							});
						}else if(filed == 'content'){
							api[handler]({id})
							.then(res=>{
								this.multext = res.data[filed];
								this.title = res.data.title;
								document.title = '湖南安邦制药股份有限公司_'+this.title;
							});
						}else{
							api[handler]({id})
							.then(res=>{
								this.video = res.data.attachUrl;
								this.title = res.data.title;
								document.title = '湖南安邦制药股份有限公司_'+this.title;
							});
						}
					} 
				},
			},
		mounted(){			
			this.getDetail();
		}
	};
</script>
<style lang="stylus">
.news_detail
    line-height 30px
	h1
		margin 30px 0
		padding 0 10px
	video
		width 100%
	.wrapper
		overflow hidden
	.detail-content
		background #f3f3f2
		.detail-border
			border 1px solid #ccc
			background #fff
			margin 30px auto
			.detail_imgTop
				width 100%
				margin-top 25px
</style>